import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateTimeUtils {
  // Assume all input strings are in UTC values and formats are ISO 8601, Date without the trailing 'Z' character or Date type
  // Returns an empty string if unable to convert input string to a date format or to the given date format
  static getLocalDateTimeFromUTCDate(utcDateTime: string | Date, format?: string): string | Date {
    const datePipe = new DatePipe('en-US');
    
    // Ensure input is a Date object (if string, convert to Date)
    let dateUtcDateTime: Date;
    if (typeof utcDateTime === 'string') {
      // If the input does not include 'Z', assume it's UTC and adjust accordingly
      // We adjust for timezone offset only when it's not the full ISO 8601 date with the 'Z' at the end.
      // TODO: Remove once the API consistently returns dates in ISO 8601 format only.
      const formattedDate = utcDateTime.endsWith("Z") || utcDateTime.includes("+") ? utcDateTime : utcDateTime + "Z";
      dateUtcDateTime = new Date(formattedDate);
    } else if (utcDateTime instanceof Date) {
      dateUtcDateTime = utcDateTime;
    } else {
      return ''; // Invalid input type
    }

    // Return empty string if the date is invalid
    if (isNaN(dateUtcDateTime.getTime())) {
      return '';
    }

    // Return the date in the specified format if provided, else return the Date object
    return format ? (datePipe.transform(dateUtcDateTime, format) ?? '') : dateUtcDateTime;
  };

  // When the user selects a date from the date-only picker, the application sets the time to 23:59:59, marking the end of the day.
  static setTimeAsEndOfTheDayWhenUserSelectValueFromDateOnlyPicker(selectedDate: Date): Date {
    return new Date(selectedDate.setHours(23, 59, 59));
  };

  static getISODateWithTAndZ(dateString: string): string {
    const datePipe = new DatePipe('en-US');
    const date = new Date(dateString);
    const formattedDate = datePipe.transform(date, 'yyyy-MM-dd');
    return `${formattedDate}T00:00:00.000Z`;
  }

  static formatDateAndTime(value: any, format?: string)
  {
    const datePipe = new DatePipe('en-US');
    return value ? datePipe.transform(value, format ?? 'MM/dd/yyyy') : value;
  }
}